(() => {
  const review = document.querySelector('.type-review');
  const typeChoice = document.getElementById('type-choice');
  if (review && typeChoice) {
    typeChoice.value = document.documentElement.dataset.type;
    typeChoice.addEventListener('change', () => {
      document.documentElement.dataset.type = typeChoice.value;
      const url = new URL(location.href);
      url.searchParams.set('type', typeChoice.value);
      history.replaceState(null, '', url);
    });
    review.querySelector('button').addEventListener('click', () => review.remove());
  }
  const M = window.MOONAS;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Header: transparent over hero, soft blur after scroll
  const hdr = document.getElementById('hdr');
  const onScroll = () => hdr.classList.toggle('scrolled', scrollY > 40);
  addEventListener('scroll', onScroll, { passive: true }); onScroll();


  // Desktop disclosure menus preserve the custom theme's shop and page navigation.
  const groups = [...document.querySelectorAll('.nav-group')];
  let menuTimer;
  const closeMenus = () => groups.forEach(g => { g.querySelector('.nav-toggle').setAttribute('aria-expanded', 'false'); g.querySelector('.nav-panel').hidden = true; });
  const openMenu = group => {
    clearTimeout(menuTimer); closeMenus();
    group.querySelector('.nav-toggle').setAttribute('aria-expanded', 'true');
    group.querySelector('.nav-panel').hidden = false;
  };
  groups.forEach(g => {
    const toggle = g.querySelector('.nav-toggle');
    toggle.addEventListener('click', () => { const open = toggle.getAttribute('aria-expanded') === 'true'; if (open) closeMenus(); else openMenu(g); });
    g.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') openMenu(g); });
    g.addEventListener('pointerleave', () => { menuTimer = setTimeout(closeMenus, 160); });
    g.addEventListener('focusout', e => { if (!g.contains(e.relatedTarget)) closeMenus(); });
    g.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); closeMenus(); toggle.focus(); }
      if (e.key === 'ArrowDown' && e.target === toggle) { e.preventDefault(); openMenu(g); g.querySelector('.nav-panel a').focus(); }
    });
  });
  document.addEventListener('click', e => { if (!e.target.closest('.nav-group')) closeMenus(); });
  matchMedia('(max-width: 1100px)').addEventListener('change', closeMenus);

  // Mobile drawer
  const btn = document.querySelector('.menu-btn'), drawer = document.getElementById('drawer');
  btn.addEventListener('click', () => {
    const open = drawer.hidden;
    drawer.hidden = !open; btn.setAttribute('aria-expanded', open);
    btn.innerHTML = M.icon(open ? 'close' : 'menu');
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    (document.querySelector('main') || {}).inert = open;
    (document.querySelector('footer.ftr') || {}).inert = open;
    if (open) drawer.querySelector('summary, a').focus(); else btn.focus();
    document.body.style.overflow = open ? 'hidden' : '';
  });
  drawer.addEventListener('click', e => { if (e.target.closest('a')) btn.click(); });
  document.addEventListener('keydown', e => {
    if (drawer.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); btn.click(); }
    if (e.key === 'Tab') {
      const controls = [...hdr.querySelectorAll('a, button'), ...drawer.querySelectorAll('a, summary')].filter(el => el.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  matchMedia('(min-width: 1101px)').addEventListener('change', e => { if (e.matches && !drawer.hidden) btn.click(); });

  // Reveal
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  const watch = root => root.querySelectorAll('.rv:not(.in)').forEach((el, i) => { el.style.transitionDelay = (i % 5) * 70 + 'ms'; io.observe(el); });
  watch(document);
  // Safety net: never leave content hidden if the observer is late
  setTimeout(() => document.querySelectorAll('.rv:not(.in)').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < innerHeight) el.classList.add('in'); }), 1500);

  // Cubit instrument (homepage only)
  if (document.querySelector('.cb-list')) {
  // Cubit instrument
  const list = document.querySelector('.cb-list'), stage = document.querySelector('.cb-sigil');
  const STORE = 'https://www.moonasmagicka.com/collections/';
  list.innerHTML = M.CUBITS.map((c, i) => `<li><button role="tab" aria-selected="${i === 0}" tabindex="${i === 0 ? 0 : -1}" data-id="${c.id}"><span class="s">${M.sigil(c, { stroke: 3, ring: 0 })}</span><b>${c.name}</b><i>${c.freq}</i></button></li>`).join('');
  function pick(id) {
    const c = M.CUBITS.find(x => x.id === id);
    list.querySelectorAll('button').forEach(b => { const selected = b.dataset.id === id; b.setAttribute('aria-selected', selected); b.tabIndex = selected ? 0 : -1; });
    stage.innerHTML = M.sigil(c, { stroke: .45, ring: .3 });
    const p = stage.querySelector('path');
    p.style.setProperty('--len', Math.ceil(p.getTotalLength()));
    if (reduce) p.style.animation = 'none';
    document.querySelector('.cb-freq').textContent = c.freq;
    document.querySelector('.cb-name').textContent = c.name + ' Cubit';
    document.querySelector('.cb-note').textContent = c.note;
    document.querySelector('.cb-go').href = STORE + c.h;
  }
  list.addEventListener('click', e => { const b = e.target.closest('button'); if (b) pick(b.dataset.id); });
  list.addEventListener('keydown', e => {
    const buttons = [...list.querySelectorAll('button')];
    const current = buttons.indexOf(e.target);
    if (current < 0) return;
    let next;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (current + 1) % buttons.length;
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (current + buttons.length - 1) % buttons.length;
    if (e.key === 'Home') next = 0;
    if (e.key === 'End') next = buttons.length - 1;
    if (next !== undefined) { e.preventDefault(); pick(buttons[next].dataset.id); buttons[next].focus(); }
  });
  pick('sacred');
  }

  if (document.querySelector('.rail')) {
  // Featured rail — live catalog data (titles, prices, photos from the store)
  const rail = document.querySelector('.rail');
  const ICON_FOR = { 'Tensor Ring': 'ring', Harmonizer: 'harmonizer', Pendant: 'pendant', Bangle: 'bangle', Pyramid: 'pyramid', Set: 'set' };
  const money = v => '$' + Number(v).toLocaleString('en-US', { maximumFractionDigits: 0 });
  Promise.resolve(window.FORGE_PRODUCTS).then(d => {
    rail.innerHTML = d.featured.map(p => `<a class="card rv" href="https://www.moonasmagicka.com/products/${p.h}">
      <div class="ph"><img src="${p.img}" alt="${p.t}" loading="lazy"><span class="tag"><span data-icon="${ICON_FOR[p.ty] || 'spark'}"></span>${p.ty}</span></div>
      <h3>${p.t}</h3>
      <div class="meta">${money(p.p)} <span>${Number(p.p) > 1500 ? 'Enquire' : 'View'}</span></div></a>`).join('');
    M.hydrate(rail); watch(rail);
  });
  const step = () => rail.firstElementChild ? rail.firstElementChild.offsetWidth + 22 : 300;
  document.querySelector('.next').onclick = () => rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
  document.querySelector('.prev').onclick = () => rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
  }

  // Hero field: copper motes travelling along toroidal orbits. Pauses offscreen; off under reduced motion.
  const cv = document.querySelector('canvas.field');
  if (!cv || reduce) return;
  const ctx = cv.getContext('2d');
  let w, h, dpr, run = true, t = 0;
  const motes = Array.from({ length: 140 }, () => ({ a: Math.random() * Math.PI * 2, r: .25 + Math.random() * .55, tilt: Math.random() * Math.PI, s: .0006 + Math.random() * .0016, z: Math.random() }));
  const size = () => { dpr = Math.min(devicePixelRatio, 2); w = cv.width = cv.offsetWidth * dpr; h = cv.height = cv.offsetHeight * dpr; };
  size(); addEventListener('resize', size);
  new IntersectionObserver(([e]) => { run = e.isIntersecting; if (run) requestAnimationFrame(loop); }).observe(cv);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && run) requestAnimationFrame(loop); });
  function loop() {
    if (!run || document.hidden) return;
    t++;
    ctx.clearRect(0, 0, w, h);
    const cx = w * (w > 1100 * dpr ? .66 : .6), cy = h * .46, R = Math.min(w, h) * .62;
    for (const m of motes) {
      m.a += m.s;
      const x = Math.cos(m.a) * R * m.r, y = Math.sin(m.a) * R * m.r * .32;
      const px = cx + x * Math.cos(m.tilt) - y * Math.sin(m.tilt), py = cy + x * Math.sin(m.tilt) + y * Math.cos(m.tilt);
      const tw = .35 + .65 * Math.abs(Math.sin(t * .01 + m.z * 9));
      ctx.fillStyle = `rgba(232,160,108,${.55 * tw * (.4 + m.z * .6)})`;
      ctx.beginPath(); ctx.arc(px, py, (.6 + m.z * 1.5) * dpr, 0, 7); ctx.fill();
    }
    requestAnimationFrame(loop);
  }
})();
